<div class="main_content position-relative">
  <section class="common-wrap">
    <div class="our-feature feature-block5" id="candidateSelfVideoIntroduction">
      <div class="container-fluid">
        <div class="row align-center">
          <div
            class="col-lg-3 wow bounceInLeft text-md-left text-center"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInLeft;
            "
          >
            <div class="display-inline">
              <div class="feature-circle">
                <img loading="lazy"
                  src="https://snatchjobs.sg/employer_asset/img/feature-img5.png"
                />
              </div>
              <div class="heading-mid text-center fb-heading">
                Candidate Self-Video <br />Introduction <br /><span
                  >(Coming Soon)</span
                >
              </div>
            </div>
          </div>
          <div
            class="col-lg-9 wow bounceInRight"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInRight;
            "
          >
            <div class="row">
              <div class="col-md-12">
                <div class="white-box mnh-250 mb-0">
                  <div class="display-flex align-center of-flex">
                    <div class="yellow-circle">
                      <img loading="lazy"
                        src="https://snatchjobs.sg/employer_asset/img/feature-icon10.png"
                        alt=""
                      />
                    </div>
                    <div class="heading-mid">
                      Get Real REVIEWS from your Customers
                    </div>
                  </div>
                  <p>
                    The review upgrade allows you to create a QR code URL for
                    your customers to leave you feedbacks in a internal feedback
                    system.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="our-feature feature-block6" id="socialMediaOutreach">
      <div class="container-fluid">
        <div class="row align-center">
          <div
            class="col-lg-3 order-2 wow bounceInRight text-md-right text-center"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInRight;
            "
          >
            <div class="display-inline">
              <div class="feature-circle">
                <img loading="lazy"
                  src="https://snatchjobs.sg/employer_asset/img/feature-img6.png"
                />
              </div>
              <div class="heading-mid text-center fb-heading">
                Social Media <br />Outreach
              </div>
            </div>
          </div>
          <div
            class="col-lg-9 wow bounceInLeft text-md-left text-center"
            data-wow-delay=".1s"
            style="
              visibility: visible;
              animation-delay: 0.1s;
              animation-name: bounceInLeft;
            "
          >
            <div class="row">
              <div class="col-md-6">
                <div class="white-box mnh-300">
                  <div class="display-flex align-center of-flex">
                    <div class="yellow-circle">
                      <img loading="lazy"
                        src="https://snatchjobs.sg/employer_asset/img/feature-icon11.png"
                        alt=""
                      />
                    </div>
                    <div class="heading-mid">
                      Filter only 5 STAR Reviews to go to your desired social
                      media
                    </div>
                  </div>
                  <p>
                    The internal system allows you to list the employees you
                    have or show a general feedback page. In this way you are
                    able to tell which employees are providing good service to
                    your clients and incentivize them correctly.
                  </p>
                  <!-- <ul>
                                        <li>Increase in reach and visibility</li><li>Increase the number of candidates</li><li>Direct advertising for your brand</li>
                                    </ul> -->
                </div>
              </div>
              <div class="col-md-6">
                <div class="white-box mnh-300">
                  <div class="display-flex align-center of-flex">
                    <div class="yellow-circle">
                      <img loading="lazy"
                        src="https://snatchjobs.sg/employer_asset/img/telegram-our-features.svg"
                        alt=""
                      />
                    </div>
                    <div class="heading-mid">
                      Reward loyal customers who leave 5 Star reviews on Social
                      Media e.g Google Reviews
                    </div>
                  </div>
                  <p>
                    This is a sure win method to see strong organic growth of
                    your social media. Customers are provided vouchers and they
                    send screenshots of their reviews to a whatsapp of your
                    choosing. Vouchers are manually sent or can be
                    self-collected at your outlet.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="top-employer-wrap">
    <div class="container-fluid">
      <div class="top-employer-flex">
        <div
          class="top-employer-left wow bounceInLeft text-md-left text-center"
          style="visibility: visible; animation-name: bounceInLeft"
        >
          <div class="main-heading">Top Employers</div>
          <div class="main-subheading">
            Companies are hiring talents on Snatchjobs
          </div>
          <ul class="employer-logos">
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/1623925683.jpg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16340307482.jpg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16335021711.jpg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16353288082.png"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16355029642.jpg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16400784001.jpg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16460208712.png"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16462044261.png"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16481201771.jpeg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16487936801.png"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16491276072.jpg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16530445292.jpg"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16577780202.png"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16584813062.png"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16638378161.png"
              />
            </li>
            <li>
              <img loading="lazy"
                src="https://snatchjobs.s3.ap-southeast-1.amazonaws.com/companies/logos/16641751932.jpg"
              />
            </li>
          </ul>
        </div>
        <div
          class="top-employer-right wow bounceInRight"
          style="visibility: visible; animation-name: bounceInRight"
        >
          <img loading="lazy"
            src="https://snatchjobs.sg/employer_asset/img/top-employer-screen.png"
          />
        </div>
      </div>
    </div>
  </section>
</div>
